import { h } from 'preact';

const CartEmpty = ({ ctaText, ctaLink, message }) => (
  <div className="lc:py-32 px-24 ml:py-40">
    {!!message?.length && (
      <div
        className="display-3 mb-32 text-center"
        data-target="text-content"
        dangerouslySetInnerHTML={{ __html: message }}
      ></div>
    )}
    {!!ctaText && !!ctaLink && (
      <a
        className="justify-center w-full button button--primary"
        href={ctaLink}
      >
        {ctaText}
      </a>
    )}
  </div>
);

export default CartEmpty;
